import { Box, InlineAlert } from '@rbilabs/universal-components';

export const IncentiveEvaluationMessagesContainer = Box;

export const SingleMessage = InlineAlert.withConfig({
  marginBottom: '$2',
  focusable: true,
});
